//import RoomActionsManager from 'socket/RoomActionsManager.js';

export default superclass => class extends superclass  {
    setupSyncing() {
        /*
        this.roomActionsManager = new RoomActionsManager(
            this.sequencerEngine, (a,b) => this.onSyncedOperation(a,b));
            */
    }

    // called from RoomActionsManager whenever we get a new operation
    // from the web socket
    onSyncedOperation({operation}, isBatch=false) {
        if (this.uuids.has(operation.uuid)) {
            // don't do operations you've already done
            return;
        }
        let action = this.getAction(operation);
        if (action === undefined) {
            // we only execute actions that we account for here
            return;
        }
        action = action.deserialize(operation);
        if (action === undefined) {
            // happens if deserialization fails/isn't defined
            // for a certain operation
            return;
        }

        this.dispatch(action, true, isBatch);
    }
}
